import { useEffect, useState } from 'react';
import { Col, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { ReactComponent as AddIcon } from "../../../assets/utils/images/svgs/Add.svg";
import { ReactComponent as SearchIcon } from "../../../assets/utils/images/svgs/search.svg";
import Loader from 'react-loaders';
import GroupStatus from 'Components/IconDropdown/Cross_Tick/GroupStatus';
import { toast } from 'react-toastify';
import { IoIosRemoveCircleOutline } from "react-icons/io";
import { useAdminsList, useUpdateRole } from 'Api/Admin/Rollen';

const UserModal = ({ setModal, modal, setRowSaved }) => {
    const [search, setSearch] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [rowClicked, setRowClicked] = useState([]);
    const [rowErrorMsg, setRowErrorMsg] = useState({});
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const { trigger: updateRole } = useUpdateRole();

    useEffect(() => {
        const timeout = setTimeout(() => {
            setDebouncedSearch(search);
        }, 500);

        return () => clearTimeout(timeout);
    }, [search]);


    const {
        trigger: fetchAdmins,
        isMutating: adminListLoading,
    } = useAdminsList();

    useEffect(() => {
        if (!modal) return;

        fetchAdmins({
            data: {
                search: debouncedSearch,
            },
        })
            .then((response) => {
                setFilteredData(response?.data || []);
            })
            .catch(() => {
                toast.error("Kan gebruikers niet ophalen");
            });
    }, [debouncedSearch, modal]);


    const toggleModal = () => {
        setModal(!modal);
        setFilteredData([]);
        setSearch("");
        setRowSaved([]);
    }

    const handleToggle = (field, value, item) => {
        const updatedList = filteredData.map(user => {
            if (user.iAdminId === item.iAdminId) {
                let updatedRoles = Array.isArray(user.roles) ? [...user.roles] : [];

                if (parseInt(value) === 1 && !updatedRoles.includes(field)) {
                    value !== 0 && updatedRoles.push(field);
                } else if (parseInt(value) === 0 && updatedRoles.includes(field)) {
                    updatedRoles = updatedRoles.filter(role => role !== field);
                }
                if (updatedRoles.length === 0) {
                    setRowErrorMsg(prev => ({
                        ...prev,
                        [item.iAdminId]: "Minimaal één rol moet geselecteerd zijn."
                    }));
                    return user;
                } else {
                    // Clear error if roles are valid again
                    setRowErrorMsg(prev => {
                        const newErr = { ...prev };
                        delete newErr[item.iAdminId];
                        return newErr;
                    });
                }

                return { ...user, roles: updatedRoles };
            }
            return user;
        });

        function rolesAreSame(oldList, newList) {
            return oldList.every((item, i) => {
                return JSON.stringify(item.roles) === JSON.stringify(newList[i].roles);
            });
        }

        if (rolesAreSame(filteredData, updatedList)) {
            return;
        }

        setFilteredData(updatedList);

        const payload = {
            "iAdminId": item.iAdminId,
            "roleType": field,
            "enable": parseInt(value)
        }

        updateRole({
            data: payload
        }).then((response) => {
            if (response?.status) {
                toast.dismiss();
                toast.success("Rol is succesvol bijgewerkt")
                setModal(false);
            } else {
                toast.dismiss();
                toast.error("Kan rol niet bijwerken")
            }
        }).catch(() => {
            toast.dismiss();
            toast.error("Kan rol niet bijwerken")
        })
    };
  
    return (
        <Modal isOpen={modal} toggle={toggleModal} className="feedback-modal-style link-form modal-centered rollen-user-modal">
            <ModalHeader toggle={toggleModal}>
                Rol gebruiker toevoegen
            </ModalHeader>
            <ModalBody className="pb-5">
                <Row>
                    <Col className=''>
                        <div className="pb-4 mt-3 melder-search">
                            <input
                                placeholder="Zoeken"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                            <SearchIcon />
                        </div>

                        <div className="melder-list">
                            {!adminListLoading ? (
                                <div className='content'>
                                    {filteredData.length > 0 ? (
                                        filteredData.map(item => (
                                            <div key={item.iAdminId}>
                                                <div className={`py-2 ${rowClicked.includes(item.iAdminId) && "border-0"} melder-li cursor-pointer`} onClick={() => {
                                                    setRowClicked(prev => {
                                                        if (prev.includes(item.iAdminId)) {
                                                            return prev.filter(id => id !== item.iAdminId);
                                                        } else {
                                                            return [...prev, item.iAdminId];
                                                        }
                                                    });

                                                }}
                                                >
                                                    <Label
                                                        for="iKetenregeling"
                                                        className="cursor-pointer"
                                                    >
                                                        {item.name}
                                                    </Label >
                                                    {rowClicked && rowClicked.includes(item.iAdminId) ?
                                                        <IoIosRemoveCircleOutline className="cursor-pointer" fontSize={20} color="#FB2E5F" />
                                                        :
                                                        <AddIcon
                                                            className={`${!rowErrorMsg[item.iAdminId] ? "cursor-pointer" : "cursor-not-allowed"}`}
                                                        />}
                                                </div>

                                                {rowClicked.includes(item.iAdminId) && (
                                                    <div className='icon-row-border pb-2'>
                                                        <Row className="py-2 w-100">
                                                            <Col className='col-4 fw-bold'>Administrator</Col>
                                                            <Col className='col-4 text-center fw-bold'>Support</Col>
                                                            <Col className='col-4 text-right fw-bold'>Documentenbeheer</Col>
                                                        </Row>
                                                        <Row className="py-2 w-100">
                                                            <Col className='col-4 pl-34'><GroupStatus iconChangeHandler={(field, value) => handleToggle(field, value, item)} field={"administrator"} data={item.roles.includes("administrator") ? 1 : 0} /></Col>
                                                            <Col className='col-4 d-flex justify-content-center'><GroupStatus iconChangeHandler={(field, value) => handleToggle(field, value, item)} field={"support"} data={item.roles.includes("support") ? 1 : 0} /></Col>
                                                            <Col className='col-4 d-flex justify-content-end pr-69'><GroupStatus iconChangeHandler={(field, value) => handleToggle(field, value, item)} field={"documentbeheer"} data={item.roles.includes("documentbeheer") ? 1 : 0} /></Col>
                                                        </Row>
                                                        {rowErrorMsg[item.iAdminId] && (
                                                            <p className="mt-1 text-danger error">{rowErrorMsg[item.iAdminId]}</p>
                                                        )}

                                                    </div>
                                                )}
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-center mt-3">Geen resultaten gevonden.</p>
                                    )}

                                </div>)
                                : (
                                    <Loader type="ball-grid-pulse" className="mt-3 d-flex mx-auto justify-content-center" />
                                )}
                        </div>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    );
};

export default UserModal;
